module.exports = __webpack_public_path__ + "static/media/user-busy.f3927356.svg";